// extracted by mini-css-extract-plugin
module.exports = {"container":"e_C5","image":"e_D5","imageImage":"e_E5","description":"e_F5","title":"e_G5","button":"e_H5"};